module.exports = __webpack_public_path__ + "img/proxima.73776fff.svg";